<app-logo-area [breadcrumbs]="breadCrumbs()"></app-logo-area>
<main>
  <app-headline-section [title]="hostName()" [badge]="'Screen ' + (monitor() + 1)">
  </app-headline-section>

  <section class="cl-section cl-section-regular">
    <div class="container">

      <!-- Status / Error -->
      @if (error()) {
        <div class="cl-alert cl-alert-danger">
          <i class="fas fa-exclamation-triangle"></i> {{ error() }}
        </div>
        <p style="text-align: center; margin-top: 1rem">
          <a class="cl-a-btn cl-a-primary" (click)="retry()">Try Again</a>
          <a class="cl-a-btn" (click)="goBack()">Back</a>
        </p>
      } @else if (!connected()) {
        <div style="text-align: center"><div class="cl-spinner">{{ status() }} <i class="fas fa-spinner fa-spin"></i></div></div>
      }

      <!-- Actions -->
      @if (connected() || password()) {
        <p class="alert cl-alert-action">
          @if (connected()) {
            <a role="button" (click)="toggleFullscreen()">Fullscreen</a>
          }
          @if (password()) {
            <a role="button" (click)="showPassword.set(!showPassword())">
              @if (showPassword()) {
                <i class="fas fa-eye-slash"></i> Hide Password
              } @else {
                <i class="fas fa-eye"></i> Show Password
              }
            </a>
          }
        </p>
      }

      <!-- Password (hidden until revealed) -->
      @if (password() && showPassword()) {
        <p>Password: <span class="cl-font-monospace">{{ password() }}</span></p>
      }

      <!-- Video -->
      <div #viewerContainer class="viewer-video-wrap" tabindex="0"
           [class.hidden]="!connected()"
           (keydown)="onKeyEvent($event)"
           (keyup)="onKeyEvent($event)"
           (paste)="onPaste($event)">
        <video #remoteVideo tabindex="0"
               playsinline
               autoplay
               (mousemove)="onMouseEvent($event)"
               (mousedown)="onMouseEvent($event)"
               (mouseup)="onMouseEvent($event)"
               (contextmenu)="$event.preventDefault()"
               (wheel)="onWheel($event)"
               (keydown)="onKeyEvent($event)"
               (keyup)="onKeyEvent($event)"
               (click)="remoteVideoRef.nativeElement.focus()">
        </video>
        <audio #remoteAudio playsinline autoplay></audio>
      </div>

    </div>
  </section>
</main>
